import React from "react"
import styled from "styled-components"

import { Card } from "components/common"

const BlogCard = (post) => {
  const renderCustom = ({ category, date }) => (
    <Hat>
      <p className="small">{category} </p>
      <span>&bull;</span>
      <p className="small">{date} </p>
    </Hat>
  )

  return (
    <StyledBlogCard>
      <Card
        {...post}
        media={{ desktop: post.cardImage }}
        custom={() => renderCustom(post)}
        to={`/blog/${post.slug}`}
      />
    </StyledBlogCard>
  )
}

const StyledBlogCard = styled.div`
  .cardImage {
    width: 100%;
    min-height: 220px;
  }
`

const Hat = styled.div`
  display: inline-grid;
  grid-template-columns: repeat(3, auto);
  grid-gap: var(--sp-8);
  align-items: center;
  margin-bottom: var(--sp-12);

  p {
    text-transform: lowercase;

    &::first-letter {
      text-transform: uppercase;
    }
    font-weight: 500;
  }
`

export default BlogCard
